import { render, staticRenderFns } from "./PortfolioCard.vue?vue&type=template&id=1caf919d&scoped=true&"
import script from "./PortfolioCard.vue?vue&type=script&lang=ts&"
export * from "./PortfolioCard.vue?vue&type=script&lang=ts&"
import style0 from "./PortfolioCard.vue?vue&type=style&index=0&id=1caf919d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caf919d",
  null
  
)

export default component.exports